<template>
	<div class="carousel-poa">
		<div id="carouselExampleControls" class="carousel slide carousel-dark" data-bs-ride="carousel" ref="carousel">
			<div class="carousel-inner">
				<div class="carousel-item active">
					<img src="images/banner-home.jpg" class="d-block w-100" alt="images/banner-home.jpg">
				</div>
				<div class="carousel-item">
					<img src="images/banner-2-poa.jpg" class="d-block w-100" alt="images/banner-home.jpg">
				</div>
				<div class="carousel-item">
					<img src="images/banner-3-poa.jpg" class="d-block w-100" alt="images/banner-home.jpg">
				</div>
			</div>
			<button @click="prevSlide" class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
				<span class="visually-hidden">Previous</span>
			</button>
			<button @click="nextSlide" class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
				<span class="visually-hidden">Next</span>
			</button>
		</div>
	</div>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
	setup() {
		const carousel = ref(null);

		onMounted(() => {
			carousel.value = new bootstrap.Carousel(carousel.value, {
				interval: 5000,
				ride: "carousel",
			});
		});

		const nextSlide = () => {
			carousel.value.next();
		};

		const prevSlide = () => {
			carousel.value.prev();
		};

		return {
			nextSlide,
			prevSlide,
			carousel,
		}
	},
};
</script>

<style scoped>
.carousel-poa {
	margin-bottom: 2rem;
}
</style>